import { type HttpGet, buildQueryString } from '@/shared/infra/http'
import type { TodoCategory } from '@/shared/domain/todo'
import type { ListTodoCategoriesForOrg } from '@/shared/domain/use-cases'

type ListTodoCategoriesResponse = { categories: TodoCategory[] }

export class EdgeListTodoCategoriesForOrgRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListTodoCategoriesForOrg = async ({ orgId, orgType }) => {
    const response = await this.http.get<ListTodoCategoriesResponse>({
      url: `/todos/categories${buildQueryString({ orgId, orgType })}`,
    })
    return response.categories
  }
}
